<div class="editor-tabs" *ngIf="editorState">

  <!-- TAB NAVIGATION -->
  <div class="tabs-nav">

    <!-- TABS -->
    <div
      *ngFor="let tab of editorState.tabs; trackBy: trackByTabId"
      class="tab"
      [class.active]="tab.id === editorState.activeTabId"
      [class.has-changes]="tab.hasChanges"
      [class.is-new]="tab.isNew"
      (click)="onTabClick(tab)"
      [matTooltip]="getTabTooltip(tab)">

      <div class="tab-content">

        <!-- ICONO -->
        <mat-icon class="tab-icon">
          {{ getTabIcon(tab) }}
        </mat-icon>

        <!-- TÍTULO -->
        <span class="tab-title">
          {{ tab.titulo || 'Sin título' }}
        </span>

        <!-- ACCIONES (CAMBIOS + CERRAR) -->
        <div class="tab-actions">
          <!-- Indicador de cambios -->
          <span
            class="change-indicator"
            *ngIf="tab.hasChanges"
            matTooltip="Archivo modificado">
            ●
          </span>

          <!-- Botón cerrar -->
          <button
            mat-icon-button
            class="tab-close"
            (click)="onTabClose($event, tab)"
            [matTooltip]="'Cerrar ' + tab.titulo">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- BOTÓN NUEVO TAB -->
    <button
      mat-icon-button
      class="new-tab-btn"
      (click)="onNewTab()"
      matTooltip="Nuevo Escrito">
      <mat-icon>add</mat-icon>
    </button>

    <!-- SPACER -->
    <div class="tabs-spacer"></div>
  </div>

  <!-- EMPTY STATE -->
  <div *ngIf="editorState.tabs.length === 0" class="empty-tabs">
    <span class="empty-message">No hay escritos abiertos</span>
    <button
      mat-icon-button
      class="new-tab-btn"
      (click)="onNewTab()"
      matTooltip="Nuevo Escrito">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
